import { BrandSchema } from "@redotech/redo-marketplace-common/brand-types";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getBrands = unaryRpc({
  name: "getBrands" as const,
  input: z.object({}),
  output: z.object({ brands: z.array(BrandSchema) }),
});
